module.exports = __webpack_public_path__ + "img/erjian_zhongji-1.a8916c18.png";